import { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import type { Post } from '@/interfaces/strapi';
import { ROUTES } from '@/constants';
import CTNIcon from '@ctn/ui/components/ctn-icon/icon';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

type PostCardProps = {
	readonly className?: string;
	readonly item: Post;
	readonly categorySlug: string;
};

const classNameComponent = 'c-cnm-post-detail';

export const PostDetail = ({ className, item, categorySlug }: PostCardProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const href = `${ROUTES.ACTUALIDAD}/${categorySlug}`;
	const date = new Date(item.publishedAt ?? item.createdAt).toLocaleDateString('es-ES', {
		year: 'numeric',
		month: 'long',
		day: '2-digit',
	});

	return (
		<section className={wrapperClassName}>
			<Link to={href} className={`${classNameComponent}__back`}>
				<CTNIcon icon="arrowLeft" size="size-16" />
				<span>Atrás</span>
			</Link>

			<time className={`${classNameComponent}__date`}>{date}</time>
			<div className={`${classNameComponent}__content`}>
				<h3 className={`${classNameComponent}__title`}>{item.name}</h3>

				{item.image?.url ? (
					<img
						src={item.image.url}
						alt={item.image.alt}
						className={`${classNameComponent}__image`}
						loading="lazy"
					/>
				) : null}

				<div className={`${classNameComponent}__body`}>
					<BlocksRenderer content={item.content} />
				</div>
			</div>

			<div
				className={classNames(`${classNameComponent}__footer`, {
					[`${classNameComponent}__footer--withFile`]: Boolean(item.file),
				})}
			>
				{item.file && (
					<Link download to={item.file.url} className={`${classNameComponent}__footer-link`}>
						Ver nota de prensa
					</Link>
				)}

				<div className={`${classNameComponent}__footer-shares`}>icon icon</div>
			</div>
		</section>
		// <article className={`${wrapperClassName} o-grid__row`}>
		// 	<div className="o-grid__col-12 o-grid__col-3@desktop">
		// 		<Link to={href}  >
		// 			{item.image?.url ? (
		// 				<img
		// 					src={item.image.url}
		// 					alt={item.image.alt}
		// 					className={`${classNameComponent}__image`}
		// 					loading="lazy"
		// 				/>
		// 			) : null}
		// 		</Link>
		// 	</div>
		// 	<div className="o-grid__col-12 o-grid__col-9@desktop">
		// 		<Link to={href} className={`${classNameComponent}__link`}>
		// 			<time className={`${classNameComponent}__date`}>{date}</time>
		// 			<h3 className={`${classNameComponent}__title`}>
		// 				{item.name}
		// 			</h3>
		// 		</Link>
		// 	</div>
		// </article>
	);
};
